// removed by extract-text-webpack-plugin
module.exports = {"title-modal":"app-components-ConfirmModal-__style___15fpQ","dialog":"app-components-ConfirmModal-__style___W-LMn","danger":"app-components-ConfirmModal-__style___jaxKM"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ConfirmModal/style.css
// module id = 2162
// module chunks = 0